<div class="canvas-container">
    <canvas width="200px" height="200px" class="canvas1"></canvas>
    <canvas width="200px" height="200px" class="canvas2"></canvas>
</div>
